import { useQuery } from "@tanstack/react-query";

import ProductTabs from "../components/Home/ProductTabs";
import HeroHome from "../components/Home/HeroHome";
import OpenYourAccount from "../components/Home/OpenYourAccount";
import Products from "../components/Home/CarouselProducts";
import { fetchProductos, fetchRankings } from "../utils/fetchers";
import useLocale from "../hooks/useLocale";
import { SkeletonRankings } from "../components/skeletons/home";
import { setTheme } from "../utils/utils";
import { __ } from "../locales/translation";

setTheme("light");

export default function HomePage() {
    const locale = useLocale();

    const { isLoading: isLoadingHomeProducts, data: homeProducts } = useQuery({
        queryKey: ["homeProducts"],
        queryFn: () => fetchProductos(locale),
        refetchOnReconnect: true,
    });

    const { isLoading: isLoadingRankings, data: homeRankings } = useQuery({
        queryKey: ["homeRankings"],
        queryFn: fetchRankings,
        select(data) {
            if (!Array.isArray(data.rankings)) return {};
    
            const sortedRankings = data.rankings.sort((a, b) => a.codigo.localeCompare(b.codigo));
    
            const content = sortedRankings.reduce((acc, item) => {
                acc[item.codigo] = item;
                return acc;
            }, {});
    
            return content;
        },
    });

    return (
        <>
            <HeroHome tag={__("Mercados")} title={__("Cotizaciones del mercado financiero")} />

            {isLoadingRankings && !homeRankings ? <SkeletonRankings /> : <ProductTabs content={homeRankings} />}

            <Products content={homeProducts?.productos || null} isLoading={isLoadingHomeProducts} />

            <OpenYourAccount data={homeProducts?.crossell} />
        </>
    );
}
